import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import config from '@/config';
import { useLogout } from '@/modules/auth/components';
import { useIsAdmin } from '@/modules/auth/hooks';
import { Button, Icon, Link } from '@/modules/ui';

import { SubscriptionType } from '../../../constants';
import { SubscriptionAlertModal } from '../SubscriptionAlertModal';
import * as felaRules from '../SubscriptionFirewall.rules';

export const CanceledSubscriptionAlert = () => {
    const isAdmin = useIsAdmin();
    const { css } = useFela();
    const logout = useLogout();

    const subscription = SubscriptionType.canceled;

    return (
        <SubscriptionAlertModal
            title={{ id: `settings.subscription.${subscription}.alert.title` }}
            text={{
                id: isAdmin ? `settings.subscription.${subscription}.alert.adminText` : `settings.subscription.${subscription}.alert.text`,
            }}
            endContent={
                <div className={css(felaRules.buttons)}>
                    {isAdmin ? (
                        <Link type='native' href={config.links.stripe} noreferrer>
                            <Button icon={<Icon type='link' customStyle={felaRules.icon} />} type='primary'>
                                <span>
                                    <FormattedMessage id={`settings.subscription.${subscription}.alert.updatePaymentMethod`} />
                                </span>
                            </Button>
                        </Link>
                    ) : null}
                    <Button
                        icon={<Icon type='logout' width='16' height='16' customStyle={felaRules.icon} />}
                        loading={logout.isPending}
                        onClick={() => {
                            logout.mutate();
                        }}
                    >
                        <span>
                            <FormattedMessage id={`settings.subscription.${subscription}.alert.logout`} />
                        </span>
                    </Button>
                </div>
            }
        />
    );
};
